/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;margin-top:6px}[_nghost-%COMP%]   .breadcrumb[_ngcontent-%COMP%]{font-size:12px;color:#fff;font-weight:400;cursor:pointer;margin-right:2.5px;text-transform:capitalize}[_nghost-%COMP%]   .breadcrumb.active[_ngcontent-%COMP%]{font-weight:600}"];
export { styles as styles };
